<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/reloadd-icon.svg" alt=""></div>
            <div><h4 class="text-semibold">Cambiar Estado</h4></div>
            <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
        </div>
        <div class="mdl-body mt-5">
            <div class="text-center text-light">
                <h5>¿Deseas cambiar el estado de este prospecto a {{data.status}}?</h5>
            </div>
        </div>
        <hr class="mt-5 mb-5">
        <div class="d-flex flex-row justify-center gap-20 mt-2">
            <button (click)="closeMdl();" class="btn btn-primary-outline text-center">Cancelar</button>
            <button class="btn btn-primary text-center">Confirmar</button>
        </div>
    </div>
</div>